var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaneStart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24.7741935px",
    height: "24px",
    viewBox: "0 0 24.7741935 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EA9F1706-EA2B-43FE-B92E-54DFB5D27A00") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Transavia",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Summary",
    transform: "translate(-812.000000, -8236.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transavia/Summary/Mobile",
    transform: "translate(788.000000, 7444.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(16.000000, 784.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "assets/icons/interface/outbound",
    transform: "translate(8.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.516129,10.0645161 C20.516129,10.0645161 18.1633548,10.0645161 15.6634839,10.0645161 L9.3003871,0 L7.36180645,0 L10.1907097,10.0683871 C8.30090323,10.0923871 5.70116129,10.3672258 3.93135484,10.5824516 L1.12490323,6.96774194 L1.77635684e-15,6.96774194 L1.54451613,12 L1.77635684e-15,17.0322581 L1.12490323,17.0322581 L3.93135484,13.4175484 C5.70116129,13.6327742 8.30090323,13.9076129 10.1907097,13.9316129 L7.36180645,24 L9.30116129,24 L15.6634839,13.9354839 C18.1633548,13.9354839 20.516129,13.9354839 20.516129,13.9354839 C22.8387097,13.9354839 24.7741935,13.0691613 24.7741935,12 C24.7741935,10.9308387 22.8147097,10.0645161 20.516129,10.0645161",
    id: "Icon"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneStart);
export default __webpack_public_path__ + "static/media/plane-start.27cc249c9ad0db15f7c034f8f856105a.svg";
export { ForwardRef as ReactComponent };